import { HttpClient } from '@angular/common/http';
import { Injectable, Signal, signal } from '@angular/core';
import { Router } from '@angular/router';
import {
  Observable,
  BehaviorSubject,
  retry,
  catchError,
  throwError,
  Subject,
  firstValueFrom,
} from 'rxjs';
import { environment } from 'src/environments/environment';

import { config } from '@core/interfaces/api_baseurl';
import { ConnectBankService } from '@page/connect-bank-account/helper/connect-bank-account.service';
import { StorageService } from '@shared/storage.service';
import { MockApiService } from '@core/mock-api-setup/mockApi.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _encryptionMode: BehaviorSubject<0 | 1 | null> = new BehaviorSubject<0 | 1 | null>(null);
  private subject = new Subject<any>();
  serviceToken: any;
  public setmobileApi = new BehaviorSubject<any>('');
  public getmobileApi = this.setmobileApi.asObservable();

  sendMessage(message: string) {
    this.subject.next(message);
  }


  public set encryptionMode(v: 0 | 1) {
    this._encryptionMode.next(v);
  }


  public get encryptionMode(): 0 | 1 {
    return this._encryptionMode.value as 0 | 1;
  }


  encryptioNsubjectValue(data: any) {
    this._encryptionMode.next(data);

  }
  //If we want send data with message and obj at same time ;

  sendMessagewithObj(message: string, obj: any) {
    this.subject.next({ text: message, data: obj });
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  clearMessages() {
    this.subject.next({});
  }

  sidebarColps: boolean = false;
  private cols = new BehaviorSubject<boolean>(this.sidebarColps);
  updateCols = this.cols.asObservable();
  countSignal = signal<number>(0);

  constructor(
    private http: HttpClient,
    private router: Router,
    private _ConnectBankService: ConnectBankService,
    private _StorageService: StorageService,
    private _MockApiService: MockApiService,
  ) { }

  toggleCols(value: boolean) {
    this.cols.next(value);
  }

  //post method with payload
  postdata(payload: any = '', path: string): Observable<any> {

    let baseurl = environment.baseurl;
    // if (path.includes('ticket') || path.includes('payout')) {
    //   baseurl = 'http://172.16.10.37/';
    // }
    // if (path.includes('auth/login')) {
    return this._MockApiService.getMockData(baseurl + path);
    // }
    return this.http
      .post<any>(baseurl + path, payload)
      .pipe(retry(0), catchError(this.errorHandler));
  }
  getQrlogos(path: any) {
    return this.http.post(environment.baseurl + path, '');
  }

  // getNotification(path: any) {
  //   return this.http.post(environment.baseurl + path, '');
  // }

  getNotificationCount() {
    this.postdata('', config.auth.getNotification).subscribe((count: any) => {
      this.countSignal.set(count.data);
    });
  }

  //post method without payload
  postHeaderwithoutpayload(path: any): Observable<any> {
    return this.postdata('',path);
    return this.http
      .post(environment.baseurl + path, null)
      .pipe(retry(0), catchError(this.errorHandler));
  }
  payload(path: any, bank_id: any): Observable<any> {
    const formData = new FormData();
    formData.append('id', bank_id);
    return this.http
      .post(environment.baseurl + path, formData)
      .pipe(retry(0), catchError(this.errorHandler));
  }

  //get method

  getData(path: any): Observable<any> {
    return this.http
      .get(environment.baseurl + path)
      .pipe(retry(0), catchError(this.errorHandler));
  }

  errorHandler(err: any) {
    console.log(err);
    let error: any = '';
    if (err.error instanceof ErrorEvent) {
      error = err.error.message;
    } else {
      error = `Error Code: ${err.status}\nMessage: ${err.message}`;
    }
    return throwError(() => err.error);
  }

  async logout(softDelete: boolean = false) {
    let payload: FormData = new FormData();
    //this.isSessionTimeOut.next(false);
    if (!softDelete) {
      await firstValueFrom(this.postHeaderwithoutpayload(config.auth.logout));
    }
    // .subscribe({
    //   next: (resp: any) => {
    //     if (resp.statuscode === 200) {

    //       // this.ngrxToaster.showSuccess(resp.msg, undefined);
    //     }
    //   },
    // });

    this._StorageService.removeItem();
    this.router.navigate(['/auth/login']);
    this._ConnectBankService.resetBankDetail();
    setTimeout(() => {
      location.reload();
    }, 1);

  }
}
